var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',_vm._l((_vm.scan_action_prototypes),function(scan_action_prototype){return _c('Item',{key:scan_action_prototype.identity,attrs:{"scan_action_prototype":scan_action_prototype}})}))}
var staticRenderFns = []

export { render, staticRenderFns }